// @flow

import React from 'react';
import classnames from 'classnames';
import { Heading } from '@riseart/common';

import {
  profileInfoCls,
  profileInfoFramedCls,
  profileInfoHeaderCls,
  profileInfoHeadingCls,
  profileInfoHeadingLabelCls,
  profileInfoBodyCls,
} from 'shared_components/quiz/common/profileinfo/ProfileInfo.less';

type Props = {
  framed?: boolean,
  label?: ?string,
  title: string,
  subtitle: string,
  children?: any,
};

export const ProfileInfo = ({
  framed = false,
  label = null,
  title,
  subtitle,
  children = null,
}: Props) => (
  <section className={classnames(profileInfoCls, { [profileInfoFramedCls]: framed })}>
    <div className={profileInfoHeaderCls}>
      <Heading tag="h1" level="2" className={profileInfoHeadingCls}>
        {label && <span className={profileInfoHeadingLabelCls}>{label}</span>}
        {title}
      </Heading>
    </div>
    <div className={profileInfoBodyCls}>
      <Heading tag="h2" level="4">
        {subtitle}
      </Heading>
      {children}
    </div>
  </section>
);
